<span
  class="mt-badge"
  [matBadge]="value"
  [matBadgeOverlap]="overlap"
  [matBadgeColor]="color"
  [matBadgePosition]="position"
>
  <ng-content></ng-content>
</span>
